import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';

import { SidePanelProvider } from '~/contexts/SidePanelContext';
import { useCameraParam } from '~/contexts/UrlParamsContext';
import {
  VehicleOptionsProvider,
  vehicleOptionsDefaultContext,
} from '~/contexts/VehicleOptionsContext';
import { ECameraType } from '~/domain/ECameraType';
import { useProductConfigurationQuery } from '~/hooks/useProductConfigurationQuery';
import { useRequestUrl } from '~/hooks/useRequestUrl';
//import JSONTREE  from '~/pages/manifest-subaru-test.json';
import { MakeURLFriendly } from '~/pages/urls';

import { IssueUrlTracker } from './IssueUrlTracker';
import { RequestPage } from './RequestPage';
import { RequestUrlTracker } from './RequestUrlTracker';

export const RequestPageContainer = React.memo(function RequestPageContainer() {
  const cameraParam = useCameraParam();
  const requestUrl = useRequestUrl();
  const { data: { cameras = [] } = {} } = useProductConfigurationQuery();
  const cameraSlug = MakeURLFriendly(cameraParam).toLocaleLowerCase();
  const camera = cameraSlug
    ? cameras.find(
        (x) => MakeURLFriendly(x.name).toLocaleLowerCase() === cameraSlug
      )
    : undefined;
  let isRetailerCamera = false;
  if (!camera) {
    // Special case for retailer since it's not in the list. This is similar logic to having a camera being undefined for feature shots.
    // All of this feels like a hack, including how it was originally developed
    if (
      cameraSlug.toLowerCase().indexOf('retailer') > -1 &&
      cameras.find((x) => x.type === ECameraType.FEATURE_RETAILER) !== undefined
    ) {
      isRetailerCamera = true;
    }
    // All of this does is stop the site from redirecting the user when /Retailer is in the url.
  }
  const vehicleOptions = useState(vehicleOptionsDefaultContext);

  if (cameras.length > 0 && cameraParam && !camera && !isRetailerCamera) {
    // redirect user to feature shots if camera is not found / no longer available
    const navigateUrl = requestUrl({ camera: undefined });

    return <Navigate to={navigateUrl} replace />;
  }

  return (
    <VehicleOptionsProvider value={vehicleOptions}>
      <SidePanelProvider>
        <RequestUrlTracker />
        <IssueUrlTracker />
        <RequestPage camera={camera} cameras={cameras} />
      </SidePanelProvider>
    </VehicleOptionsProvider>
  );
});
